import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'
import initGalleries from '@resources/js/components/galleries'

import FormView from '@resources/js/components/form/FormView'
import FormStore from '@resources/js/components/form/FormStore'
import { syncFormStoreWithSession } from '@resources/js/components/form/formStoreSync'
import FormPresenter from '@resources/js/components/form/FormPresenter'
import Modal from '@resources/js/ui/Modal'
import { updateFormInfoView } from '@resources/js/components/form/helpers/updateFormInfoView'
import { isDesktop } from '@resources/js/helpers/media'
import handleCalendarFormSubmit from '@resources/js/helpers/handleCalendarFormSubmit'
import '@resources/js/analytics'
import Sticky from '@resources/js/ui/Sticky'
import ScrollSpy from '@resources/js/ui/ScrollSpy'
import ScrollFog from '@resources/js/ui/ScrollFog'
import initAiButton from '@resources/js/components/ai-button/initAiButton'

const partnerType = getBcomOrExpediaPartnerType()

initSharedPromotion()

initGalleries()

initAiButton()

const FORM_SELECTOR = '.js-form'
const FORM_WRAPPER_SELECTOR = '.js-form-wrapper'
const DATE_FORMAT = 'D MMM, YYYY' // 1 Apr, 2025
const hotelMainRootElement = document.querySelector('.js-hotel-main')

// спільний стор для форми
const formStore = new FormStore()
syncFormStoreWithSession(formStore)

// main form
const formHeroWrapperElement =
	hotelMainRootElement.querySelector(FORM_WRAPPER_SELECTOR)

const mainFormView = new FormView(
	formHeroWrapperElement.querySelector(FORM_SELECTOR)
)
const mainFormPresenter = new FormPresenter(mainFormView, formStore, DATE_FORMAT)

// Header desktop form
const headerRootElement = document.querySelector('.js-header')

const headerFormView = new FormView(headerRootElement.querySelector(FORM_SELECTOR))
const headerFormPresenter = new FormPresenter(headerFormView, formStore, DATE_FORMAT)

const initFogNavigation = () => {
	const fogWrapElement = headerRootElement.querySelector('.js-scroll-fog')
	const fogNavElement = fogWrapElement.querySelector('.js-hotel-nav')

	new ScrollFog(fogNavElement, fogWrapElement)
}

const initNavigation = () => {
	const headerElHeight = headerRootElement.clientHeight
	// активна зона ScrollSpy - смуга одразу під хедером, а не коли блок зʼявляється во вьюпорті
	const ACTIVE_ZONE_PX = 10
	const bottomMargin = window.innerHeight - headerElHeight - ACTIVE_ZONE_PX

	const navTrackElements = hotelMainRootElement.querySelectorAll(
		'.js-nav-track-section'
	)
	navTrackElements.forEach(el => {
		el.style.scrollMarginTop = `${headerElHeight}px`
	})

	const navigationRootElement = headerRootElement.querySelector('.js-hotel-nav')

	new ScrollSpy(navigationRootElement, navTrackElements, {
		rootMargin: `-${headerElHeight}px 0px -${bottomMargin}px`,
	})
}

const initStickyHeader = () => {
	const heroElement = hotelMainRootElement.querySelector('.js-hero')
	const breadcrumbsElement = hotelMainRootElement.querySelector('.js-breadcrumbs')
	const breadcrumbsHeight = breadcrumbsElement?.offsetHeight ?? 0

	const stickyHeaderInstance = new Sticky(headerRootElement, {
		top: heroElement.offsetHeight + breadcrumbsHeight,
		toggleClass: 'with-form',
	})

	const handleSetSticky = () => {
		stickyHeaderInstance.off('set-sticky', handleSetSticky)
		initNavigation()
		initFogNavigation()
	}

	stickyHeaderInstance.on('set-sticky', handleSetSticky)
}

mainFormPresenter.on('form-submit', formData =>
	handleCalendarFormSubmit({ partnerType, formData })
)
headerFormPresenter.on('form-submit', formData =>
	handleCalendarFormSubmit({ partnerType, formData })
)

if (!isDesktop()) {
	// щоб при відкритті formHeroWrapperElement елемент headerRootElement не був перекритим
	const headerInnerElement = headerRootElement.querySelector('.js-header-inner')
	formHeroWrapperElement.style.top = `${headerInnerElement.clientHeight}px`

	// додаємо hotelAvailInfoElement - щоб елемент з класом js-show-form-trigger шукався саме в form-info_2
	const hotelAvailInfoElement = headerRootElement.querySelector(
		'.js-header-avail-info'
	)
	const showFormTriggerElement = hotelAvailInfoElement.querySelector(
		'.js-show-form-trigger'
	)

	const formModal = new Modal(formHeroWrapperElement, {
		trigger: showFormTriggerElement,
		selectors: {
			close: '.js-hide-form-trigger',
			content: FORM_WRAPPER_SELECTOR,
		},
	})

	updateFormInfoView(formStore.getData())

	formStore.on('change', () => {
		updateFormInfoView(formStore.getData())
	})

	mainFormPresenter.on('form-submit', () => formModal.hide())

	const formSubmitTriggerElement = headerRootElement.querySelector(
		'.js-form-info-submit'
	)

	formSubmitTriggerElement.addEventListener('click', () =>
		handleCalendarFormSubmit({ partnerType, formData: formStore.getData() })
	)
}

initStickyHeader()
